import { render, staticRenderFns } from "./TopMessagengUsers.vue?vue&type=template&id=a4505be8&"
import script from "./TopMessagengUsers.vue?vue&type=script&lang=js&"
export * from "./TopMessagengUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports